interface ImageAPIOptions {
  width?: number;
  height?: number;
  quality?: number;
}

export const imageSrcWith = (src: string | undefined, { width, height, quality = 80 }: ImageAPIOptions) => {
  try {
    if (!src?.includes("contentstack")) return src || "";
    const url = new URL(src);
    const params = new URLSearchParams(url.search);
    if (width && !params.has("width")) params.set("width", width.toString());
    if (height && !params.get("height")) params.set("height", height.toString());
    if (quality && !params.get("height")) params.set("quality", quality.toString());
    url.search = params.toString();
    return url.toString();
  } catch (e) {
    // do nothing in case of error
    return src || "";
  }
};
